module.exports = __webpack_public_path__ + "img/news5.6ee1fbf8.svg";